import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Helpers } from 'src/app/core/helpers';
import { KeycloakConfig } from 'src/app/core/keycloak/keycloak-config';
import { Role } from 'src/app/core/models/role';
import { MeService } from 'src/app/core/services/api/me.service';
import { ThemeService } from 'src/app/core/services/app/theme.service';

@Component({
	selector: 'app-base',
	templateUrl: './base.component.html',
	styleUrls: ['./base.component.less']
})
export class BaseComponent implements OnInit, OnDestroy {
	private _subscriptions: Array<Subscription> = [];
	isCollapsed = false;
	helpers = Helpers;
	role = Role;

	constructor(private themeService: ThemeService, private _meService: MeService) { }

	ngOnInit(): void {
		if (!Helpers.getMe()) {
			this._subscriptions.push(this._meService.GETMe().subscribe({
				next: (response: any) => {
					localStorage.setItem('Me', JSON.stringify(response.data));
				},
				error: (err) => {
					throw new Error(err);
				}
			}))
		} else {
		}
	}

	toggleTheme(): void {
		this.themeService.toggleTheme().then();
	}

	logout() {
		KeycloakConfig.keycloakLogout();
	}

	ngOnDestroy(): void {

	}
}
